export enum ListActivityTypesEnum {
  AccountRequested = 1,
  AccountActivated = 2,
  AccountDeactivated = 3,
  AccountUpdated = 4,
  UserCreated = 5,
  UserUpdated = 6,
  UserLogin = 7,
  UserLogout = 8,
  UserActivated = 9,
  UserForgotPassword = 10,
  UserResetPassword = 11,
  UserDeactivated = 12,
  LocationUploadedToList = 13,
  LocationDeletedFromList = 14,
  LocationCopiedToList = 15,
  LocationUpdatedInList = 16,
  LocationMovedFromList = 17,
  ListCreated = 18,
  ListUpdate = 19,
  ListUpdateNew = 20,
  ListDeleted = 21,
  ListAnalyzing = 22,
  // see backward compat comment and code below (listActivityByID[23-25])
  ListShared = 35,
  ListUnShared = 36,
  ListUnSharedWithAll = 37,
  ConnectionRequested = 28,
  ConnectionAccepted = 29,
  ConnectionRejected = 30,
  ConnectionResent = 31,
  ConnectionCancelled = 32,
  // new entries should start with value 38
  ListGetPaginatedListInfo = 38, // see backward compat comment and code below (listActivityByID[23-25])
  ListInfo = 39,
  ListPrepareUpload = 40,
  ListGenerate = 41,
  ListDetailsDownload = 42,
  ListLandingDownload = 43,
  ListDashboardDownload = 44,
  ListDiagnosticsDownload = 45,
}
